import { createFileRoute } from '@tanstack/react-router'

import { MassJobsPage } from '#/modules/system/mass-jobs-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/mass-jobs')({
  component: MassJobsPage,
  validateSearch: validateListSearch,
})
